import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { PRIVACY_URL } from "@/data/content";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("sf-cookie-consent")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("sf-cookie-consent", value);
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[100] rounded-2xl bg-white border border-ink/10 shadow-2xl p-6"
        >
          <div className="flex items-start gap-4">
            <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-azure/10 text-brandblue">
              <Cookie size={20} />
            </span>
            <div>
              <p className="font-semibold text-sm text-ink">Cookie e privacy</p>
              <p className="mt-1.5 text-xs text-ink/60 leading-relaxed">
                Utilizziamo cookie tecnici per far funzionare il sito e, previa autorizzazione,
                cookie di misurazione e marketing (Google Analytics e Meta Pixel) per migliorarlo
                e valutare le nostre campagne. Leggi l'
                <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="text-brandblue underline underline-offset-2" data-testid="cookie-privacy-link">
                  informativa completa
                </a>
                .
              </p>
              <div className="mt-4 flex gap-3">
                <button
                  onClick={() => choose("all")}
                  data-testid="cookie-accept-btn"
                  className="flex-1 bg-azure hover:bg-brandblue text-white text-xs font-semibold rounded-full px-4 py-2.5 transition-colors duration-300"
                >
                  Accetta tutti
                </button>
                <button
                  onClick={() => choose("technical")}
                  data-testid="cookie-reject-btn"
                  className="flex-1 border border-ink/20 text-ink/70 hover:bg-ink/5 text-xs font-semibold rounded-full px-4 py-2.5 transition-colors duration-300"
                >
                  Solo tecnici
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
